import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Mobilenavbar.css';

const MobileMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [aboutSubMenuOpen, setAboutSubMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleAboutSubMenu = () => {
        setAboutSubMenuOpen(!aboutSubMenuOpen);
    };

    return (
        <div>
            <div>
                <div className="hamburger-menu" onClick={toggleMenu} style={{ marginLeft: "300px", marginTop: "150px" }}>
                    <div className={`bar ${isMenuOpen ? 'animate' : ''}`}></div>
                </div>

                <nav className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>

                    {/* <Link to="/">
                        <img src="./Images/Logo.png" alt="Logo" />
                    </Link>
                    <ul className='responsive_cerficate_company'>
                        <li><strong style={{ color: "white" }}>Certified Company</strong></li>
                        <li style={{ color: "white" }}>ISO 9001:2015</li>
                    </ul> */}

                    <ul>
                        <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
                        <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link></li>
                        <li className={`has-children ${aboutSubMenuOpen ? 'open' : ''}`} onClick={toggleAboutSubMenu}>
                            <Link to="/product" onClick={() => setIsMenuOpen(false)}> {/* This is the modification */}
                                <span>Products <span className={`icon-arrow ${aboutSubMenuOpen ? 'open' : ''}`}></span></span>
                            </Link> {/* This is the modification */}
                            <ul className={`children ${aboutSubMenuOpen ? 'open' : ''}`}>
                                <li><Link to="/about/submenu1" onClick={() => setIsMenuOpen(false)}>Submenu #1</Link></li>
                                <li><Link to="/about/submenu2" onClick={() => setIsMenuOpen(false)}>Submenu #2</Link></li>
                                <li><Link to="/about/submenu3" onClick={() => setIsMenuOpen(false)}>Submenu #3</Link></li>
                            </ul>
                        </li>
                        <li><Link to="/PerforatedSheets" onClick={() => setIsMenuOpen(false)}></Link></li>

                        <li><Link to="/PerforatedSheets" onClick={() => setIsMenuOpen(false)}>PerforatedSheets</Link></li>
                        <li><Link to="/FuelStrainers" onClick={() => setIsMenuOpen(false)}>FuelStrainers</Link></li>
                        <li><Link to="/PressComponents" onClick={() => setIsMenuOpen(false)}>PressComponents</Link></li>
                        <li><Link to="/SpotWelding" onClick={() => setIsMenuOpen(false)}>SpotWelding</Link></li>
                        <li><Link to="/PerforatedSheets" onClick={() => setIsMenuOpen(false)}></Link></li>
                        <li><Link to="/gallery" onClick={() => setIsMenuOpen(false)}>Gallery</Link></li>
                        <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contactus</Link></li>
                    </ul>
                    {/* <ul>
                        <li><i class="fa fa-mobile-alt"></i><a href="#">+91 9980411999 <br />+91 ⁠9845164986</a></li>
                        <li><i class="fa fa-envelope" aria-hidden="true"></i><a href="mailto:autometengg2@gmail.com" style={{ fontSize: "15px" }}>autometengg2@gmail.com</a></li>
                    </ul> */}
                </nav>
            </div>


        </div>
    );
};

export default MobileMenu;